import React from 'react';
import { Navigate } from 'react-router-dom';
import { adminAuthService } from '../../services/adminAuth';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = adminAuthService.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
